module.exports = __webpack_public_path__ + "img/login-logo.c3834943.png";